import { Grid } from "@mui/material";
import React from "react";
import { Edit as EditIcon } from "@mui/icons-material";
import SecondaryDeviceInformationForm from "./SecondaryDeviceInformationForm";
import SecondaryDeviceInformationPreview from "./SecondaryDeviceInformationPreview";

const SecondaryDeviceInformation = ({
  isLoading,
  isEditMode,
  handleSubmit,
  setIsEditMode,
  currentUserRole,
  handleCancelClick,
  deviceInformation,
  hasIncompleteRpmInformation,
  deviceInformationEditAccessRoles,
}) => {
  return (
    <div className="patient-form__row patient-form__info">
      <div className="mb-3">
        <Grid container display="grid">
          <Grid container item>
            <Grid
              item
              xs={11}
              style={{ textAlign: "left", marginBottom: "5px" }}
            >
              <div className="device-info__device-title">SECONDARY DEVICE</div>
            </Grid>
            {!isEditMode &&
              deviceInformationEditAccessRoles.includes(currentUserRole) && (
                <Grid item xs={1} style={{ textAlign: "right" }}>
                  <span
                    class="device-edit-button"
                    onClick={() => setIsEditMode(true)}
                  >
                    <EditIcon
                      className="patient-edit-icon billing-cycle-edit-icon"
                      data-action="edit-secondary-device-information-icon"
                    />
                    Edit
                  </span>
                </Grid>
              )}
          </Grid>
          {isEditMode ? (
            <SecondaryDeviceInformationForm
              handleCancelClick={() => handleCancelClick(false)}
              handleSubmit={handleSubmit}
              isLoading={isLoading}
            />
          ) : (
            <SecondaryDeviceInformationPreview
              deviceInformation={deviceInformation}
            />
          )}
        </Grid>
      </div>
    </div>
  );
};

export default SecondaryDeviceInformation;
